import Handlebars from 'handlebars';
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';


// Helper to convert hyperlink objects to HTML strings
const preprocessTemplateData = (data) => {
    if (!data || typeof data !== 'object') return data;
    const processed = {};
    for (const key in data) {
        if (
            data[key] &&
            typeof data[key] === 'object' &&
            data[key].type === 'hyperlink'
        ) {
            processed[key] = `<a href="${data[key].link}" target="_blank" rel="noopener noreferrer">${data[key].display_text}</a>`;
        } else {
            processed[key] = data[key];
        }
    }
    return processed;
};

const compileTemplate = (templateString, data) => {
    if (!templateString) return "";
    // Preprocess data to convert hyperlink objects to HTML strings
    const processedData = preprocessTemplateData(data);
    // Compile the Handlebars template
    const template = Handlebars.compile(templateString);
    const rawHtml = template(processedData);
    // Sanitize the HTML before returning, allowing target attribute
    const cleanHtml = DOMPurify.sanitize(rawHtml, { ADD_ATTR: ['target'] });
    return parse(cleanHtml);
}

const button_text_inner_mapping ={
    "clear-biometric-opt-in": "Verify your Identity with CLEAR",
    "clear-biometric-opt-out": "Sign up for another way to verify your identity",
    "clear-verification-ineligible": "Sign up for another way to verify your identity"
}

// Landing page data - country selection button text
const country_selection_placeholder = [
    {
    "consent_group": "group1",
    "consent_api_key": "clear-biometric-opt-in",
    "button_text": "",
    "consent_available": ["clear-biometric-opt-in"],
}, 
{
    "consent_group": "group2",
    "consent_api_key": "clear-biometric-opt-out",
    "button_text": "",
    "consent_available": ["clear-biometric-opt-in", "clear-biometric-opt-out"]    
},
{
    "consent_group": "allOthers",
    "consent_api_key": "clear-verification-ineligible",
    "button_text": "",
    "consent_available": ["clear-verification-ineligible"]
    }
];

export const formatData = (data) => {
    const template_data = data.placeholder_mapping;
    let consent_data = {};
    for (const key in data) {
        if (key === "placeholder_mapping" || key === "enrollmentStatus" || 
            key === "enforcedEnrollment" || key === "userMessage") continue;
        Object.assign(consent_data, {
            [key]: {
                button_text_inner: data[key]?.button_text || button_text_inner_mapping[key],
                consent_language: compileTemplate(data[key]?.language, template_data),
                consent_id: data[key]?.version
            }
        });
    }
    const country_selection = country_selection_placeholder.map(item => ({
        ...item,
        button_text: data[item.consent_api_key]?.button_txt || '',
    }));
    return {country_selection, consent_data};
}
    